// removed by extract-text-webpack-plugin
module.exports = {"input-field":"currency-tax-language-settings__input-field___3sKFR","small":"currency-tax-language-settings__small___GfAw-"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/currency-tax-language-settings.scss
// module id = 1358
// module chunks = 0